module.exports = __webpack_public_path__ + "static/flags/TI-dadf0b715647914dec9d7d20917bdb07.gif";